import styled from 'styled-components';
import {white } from './utils/colors';

export const ButtonStyled = styled.a`
  cursor: pointer;
`;

export const Image = styled.img`
  color: ${white};
  height: 36px;
  width: 36px;
`;